export const CATEGORY_COLORS = {
  Alimentation:  { color: '#3b8c5a', textColor: '#fff', borderColor: '#3b8c5a' },
  Transport:     { color: '#2563eb', textColor: '#fff', borderColor: '#2563eb' },
  Logement:      { color: '#7c3aed', textColor: '#fff', borderColor: '#7c3aed' },
  'Santé':       { color: '#dc2626', textColor: '#fff', borderColor: '#dc2626' },
  Loisirs:       { color: '#d97706', textColor: '#fff', borderColor: '#d97706' },
  Abonnements:   { color: '#0891b2', textColor: '#fff', borderColor: '#0891b2' },
  Maison:        { color: '#b45309', textColor: '#fff', borderColor: '#b45309' },
  Autre:         { color: '#6b7280', textColor: '#fff', borderColor: '#6b7280' },
};

export const CATEGORY_OPTIONS = Object.keys(CATEGORY_COLORS).map(k => ({ label: k, value: k }));

export const PERIODICITY_OPTIONS = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Annual', value: 'Annual' },
  { label: 'One-off', value: 'One-off' },
];

export const ACCOUNT_TYPE_OPTIONS = [
  { label: 'Individual', value: 'Individual' },
  { label: 'Shared', value: 'Shared' },
];

export function formatCurrency(value) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  }).format(value || 0);
}

export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString();
}

export function getCategoryColor(category) {
  return CATEGORY_COLORS[category] ?? CATEGORY_COLORS.Autre;
}

export function getPeriodicityType(periodicity) {
  switch (periodicity) {
    case 'Monthly': return 'info';
    case 'Annual': return 'warning';
    case 'One-off': return 'success';
    default: return 'default';
  }
}

export function getTargetType(target) {
  switch (target) {
    case 'Individual': return 'primary';
    case 'Shared': return 'error';
    default: return 'default';
  }
}
